import request from '@/http/request'

export const skuInfoByQrCodeOrEpc = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/nfc/rf/device/skuInfoByQrCodeOrEpc`, params, {
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}
